import Moment from 'moment';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);

const dayOpenings = (dayChosen, openings, minimumTimePassed = 90) => {
  // console.log('data arrived', dayChosen, openings);
  const weekDay = moment(dayChosen).locale('en').format('dddd').toLowerCase();
  // console.log(weekDay);
  const openingsDay = openings.find(el => el.weekDay === weekDay);
  const day = moment(dayChosen).format('YYYY-MM-DD');
  // console.log(day);

  if (openingsDay && openingsDay.hoursRange && openingsDay.hoursRange.length > 0) {
    const a = openingsDay.hoursRange.map((e) => {
      if (e.hourTo === '00:00') {
        e.hourTo = '23:59';
      }
      const day2 = `${day}T${e.hourTo}:00`;
      const day1 = `${day}T${e.hourFrom}:00`;
      const range = moment.range(moment(day1), moment(day2));
      const years = Array.from(range.by('minutes', { step: 30, excludeEnd: true }));
      return years.map((m) => {
        if (m.isBefore(moment().add(minimumTimePassed, 'minutes'))) {
          return null;
        }
        return m.format('HH:mm');
      }).filter(Boolean);
    });
    const b = [].concat(...a);
    const e = b.sort((c, d) => {
      const f = Number(c.replace(':', ''));
      const g = Number(d.replace(':', ''));
      return f - g;
    });
    return e;
  }
  return [];
};

export const dayOpeningsReservationData = (dayChosen, openings, minimumTimePassed = 90) => {
  console.log('data arrived', dayChosen, openings);

  const weekDay = moment(dayChosen).isoWeekday();
  const day = dayChosen.format('YYYY/MM/DD');
  // console.log(weekDay);
  const hours = [].concat(...openings.map((el) => {
    if (el.weekSystem[weekDay]) {
      if (el.weekSystem[weekDay].messageSelected && el.weekSystem[weekDay].messageSelected === 'custom') {
        return el.weekSystem[weekDay].hours.map((es) => {
          const ed = es;
          ed.customText = el.weekSystem[weekDay].customText;
          return ed;
        });
      }
      return el.weekSystem[weekDay].hours;
    }
    return null;
  }

    ).filter(Boolean)
  );
  console.log(hours);
  const available = hours.map((el) => {
    const hourWithMoment = moment(`${day} ${el.hour}`, 'YYYY/MM/DD HH:mm');
    if (!el.isActive) {
      return null;
    } else if (hourWithMoment.isBefore(moment().add(minimumTimePassed, 'minutes'))) {
      return null;
    }
    return el;
  });
  return available.filter(Boolean);
  // const openingsDay = openings.find(el => el.weekDay === weekDay);
  // const day = moment(dayChosen).format('YYYY-MM-DD');
  // // console.log(day);
  //
  // if (openingsDay && openingsDay.hoursRange && openingsDay.hoursRange.length > 0) {
  //   const a = openingsDay.hoursRange.map((e) => {
  //     if (e.hourTo === '00:00') {
  //       e.hourTo = '23:59';
  //     }
  //     const day2 = `${day}T${e.hourTo}:00`;
  //     const day1 = `${day}T${e.hourFrom}:00`;
  //     const range = moment.range(moment(day1), moment(day2));
  //     const years = Array.from(range.by('minutes', { step: 30, excludeEnd: true }));
  //     return years.map((m) => {
  //       if (m.isBefore(moment().add(minimumTimePassed, 'minutes'))) {
  //         return null;
  //       }
  //       return m.format('HH:mm');
  //     }).filter(Boolean);
  //   });
  //   const b = [].concat(...a);
  //   const e = b.sort((c, d) => {
  //     const f = Number(c.replace(':', ''));
  //     const g = Number(d.replace(':', ''));
  //     return f - g;
  //   });
  //   return e;
  // }
  // return [];
};

export default dayOpenings;
